// @ts-nocheck
export const TABLE_ID = 92;
// export const TABLE_ID_STORAGE = 93;

export const STORE_PREFIX = 'planogram/listing';

export const MENU_ITEMS_NAMES = {
	CUSTOMIZE_VIEW: 'Customize View',
	RESET_VIEW: 'Reset View',
	UPLOAD_DATA: 'Upload Data',
	DELETE: 'Deactivate'
};

export const UPLOAD_PAGES = {
	STORES: 'STORES',
	ATTRIBUTES: 'ATTRIBUTES'
}

export const LOADER_COMPONENTS = {
	SAVE_ATTRIBUTE_DETAILS: "SAVE_ATTRIBUTE_DETAILS"
}
export const MENU_ITEMS_VALUES = {
	CUSTOMIZE_VIEW: 'CUSTOMIZE_VIEW',
	RESET_VIEW: 'RESET_VIEW',
	UPLOAD_DATA: 'UPLOAD_DATA',
	DELETE: 'DELETE'
};

export const MENU_ITEMS = [

	{
		displayName: MENU_ITEMS_NAMES.RESET_VIEW,
		value: MENU_ITEMS_VALUES.RESET_VIEW
	},
	{
		displayName: MENU_ITEMS_NAMES.UPLOAD_DATA,
		value: MENU_ITEMS_VALUES.UPLOAD_DATA
	},
	{
		displayName: MENU_ITEMS_NAMES.DELETE,
		value: MENU_ITEMS_VALUES.DELETE
	}
];
